import React from 'react';
import styled from 'styled-components';

import { BLUE_GREY } from '../../../theme';

const Container = styled.div`
  font-size: 12px;
  line-height: 1.17;
  letter-spacing: -0.1px;
  color: ${BLUE_GREY};
`;

const FunderReviewFormFootnote = () => (
  <Container>
    Les données de ce formulaire font l’objet de traitements dont le responsable est Vroom France - 13 rue Olier 75015 Paris.
    Elles sont utilisées pour permettre à l’auto-école de respecter le critère 7.2 du label « Qualité des formations au sein des écoles de conduite ».
    Elles ne font l’objet d’aucune utilisation commerciale. Elles sont conservées pour une durée maximale de cinq (5) ans.
    Vous disposez d’un droit d’accès, de rectification, de limitation, de portabilité, d’opposition, de suppression et vous pouvez définir
    des directives post mortem relatives à vos données. Vous pouvez exercer vos droits en envoyant un email à
    {' '}
    <a href="mailto:contact@vroomvroom.fr">contact@vroomvroom.fr</a>
    {' '}
    ou en contactant le Délégué à la protection des données de Vroom France. Pour en savoir plus, vous pouvez consulter notre
    {' '}
    <a href="/a-propos/donnees-personnelles" target="_blank" rel="noopener noreferrer">
      politique de protection des données.
    </a>
  </Container>
);

export { FunderReviewFormFootnote };
